export default {
  unavailable: {
    title: 'Accesul self-service pentru parteneri este limitat',
    description:
      'Această secțiune nu este disponibilă pentru partenerii cu configurare self-serve. Contactați managerul de cont dacă aveți nevoie de ea.',
  },
};
